const milestones = [
  ['18 Feb 2026', 'Battery carbon declaration'],
  ['11 Sep 2026', 'Cyber Resilience Act · reporting'],
  ['20 Jan 2027', 'Machinery Regulation (EU) 2023/1230'],
  ['18 Feb 2027', 'Digital battery passport'],
  ['11 Dec 2027', 'Cyber Resilience Act · full application'],
] as const;

const standards = ['EN ISO 3691‑4:2023', 'ISO 10218‑1:2025', 'ISO 10218‑2:2025', 'EMC', 'LVD', 'RED', 'UN 38.3', 'RoHS', 'WEEE'];

export function Accountability() {
  return (
    <section className="sec sec--dark" id="accountable">
      <div className="sec__label">One accountable party</div>
      <h2 className="big drift">One contract.<br />Whole system.</h2>
      <p className="sec__sub reveal">Hardware, integration, service and conformity are all signed by one company.</p>

      <div className="time">
        {milestones.map(([date, title], index) => (
          <div className={`time__row reveal${index === 2 ? ' time__row--key' : ''}`} key={date}>
            <span className="time__d">{date}</span><span className="time__b"></span><h3>{title}</h3>
          </div>
        ))}
      </div>

      <div className="std reveal">{standards.map((standard) => <span key={standard}>{standard}</span>)}</div>
      <p className="fineprint reveal">We confirm the qualification scope with a compliance consultant before you sign.</p>
    </section>
  );
}
